import css from './Experience.module.scss'
// import SectionTitle from "../../SectionTitle";
import {experience} from "../../config/data"
import ExperienceCard from "./ExperienceCard";
import Title from "../Title";
// import SVGPath from "./SVGPath";

const Experience = (props) => {
  return (
      <div id={css.experience} className={'px-5'}>
        <Title title={'Experience'}/>
        <div className='pt-6'>
          <div className='grid md:grid-cols-2 gap-4'>
            {experience && experience.map((xp, i) => (
                <ExperienceCard xp={xp} key={i}></ExperienceCard>
            ))}
          </div>
        </div>
      </div>
  );
}

export default Experience;
